import { render } from "./ShouKuan.vue?vue&type=template&id=782bb677"
import script from "./ShouKuan.vue?vue&type=script&lang=js"
export * from "./ShouKuan.vue?vue&type=script&lang=js"

import "./ShouKuan.vue?vue&type=style&index=0&id=782bb677&lang=less"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__